var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80146 20.6571C6.80146 22.5032 5.30471 24 3.45859 24C1.61248 24 0.115723 22.5032 0.115723 20.6571V3.34287C0.115723 1.49675 1.61248 0 3.45859 0C5.30471 0 6.80146 1.49675 6.80146 3.34287V20.6571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3474 20.6571C19.3474 22.5032 17.8506 24 16.0045 24C14.1584 24 12.6616 22.5032 12.6616 20.6571V3.34287C12.6621 1.49675 14.1589 0 16.0045 0C17.8506 0 19.3474 1.49675 19.3474 3.34287V20.6571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.6ba89d579d461eb2b13a97284d3dae83.svg";
export { ForwardRef as ReactComponent };